import { useMutation } from '@tanstack/react-query';
import {
  signInWithEmailAndPassword,
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
} from 'firebase/auth';
import { auth } from 'src/config/firebase';
import { IAuthLoginPayload } from '../interfaces/auth';

export function useAuthLogin() {
  return useMutation({
    mutationFn: async (payload: IAuthLoginPayload) => {
      const { email, password, rememberMe } = payload;

      // Set persistence based on "remember me"
      await setPersistence(auth, rememberMe ? browserLocalPersistence : browserSessionPersistence);

      const userCredential = await signInWithEmailAndPassword(auth, email, password);

      if (!userCredential.user.emailVerified) {
        // await signOut(auth); // Keep Firebase auth alive so the user can resend the verification email
        throw new Error(
          'Please verify your email before logging in. Check your inbox/spam folder.',
        );
      }

      return userCredential.user;
    },
  });
}
